import React from "react";
import './Session.css';

import { speakers } from "../../constants";
import { getSpeakersByIds } from "../../utils";

import { Link } from "react-router-dom";



const Session = ({ session }) => {

  // Get the speakers for this session
  const sessionSpeakers = getSpeakersByIds(session.speakerIds, speakers);

  return (

    <div className="session">

      {/* Session Intro Section */}
      <div className="session-intro">
        <img src={session.image} alt={session.title} /> {/* Session Image */}
        <div className="intro-content">
          <div className="session-timing">{session.details.time}</div> {/* Session Time */}
          <div className="session-venue">{session.details.venue}</div> {/* Session Venue */}
        </div>
      </div>

      {/* Session Topic Section */}
      <div className="session-topic">
        {/* Link to the individual session page */}
        <Link
          to={{ 
            pathname: '/Schedule/' + session.title,  // Navigate to the specific session page
          }}
          location = {{session}}  // Passing session details to the linked page
          state= {session}> 
          <h3>{session.title}</h3> {/* session Title */}
        </Link>
        <p>{session.content}</p> {/* Session description */}
      </div>

      {/* Session Speaker Section */}
      <div className="session-speakers">
        {sessionSpeakers.length > 0 && (
          <div className="session-speaker">
            <img src={sessionSpeakers[0].image} alt={sessionSpeakers[0].name} /> {/* Speaker Image */}
            <div className="text">
              <h4>{sessionSpeakers[0].name}</h4> {/* Speaker Name */}
              <h6>{sessionSpeakers[0].title}</h6> {/* Speaker Designation */}
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default Session;